import { css } from 'astroturf';
import React, { Component } from 'react';
import Link from '../link';

const styles = css`
  .expense {
    text-align: left;
    max-width: 32rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    flex-direction: column;
    padding: 1rem;
    font-size: 1rem;

    @media (min-width: 400px) {
      padding: 0;
      flex-direction: row;
    }

    & svg {
      flex: 0 0 128px;
    }

    & h2 {
      font-size:26px;
      line-height: 1.1;
      margin-bottom: 0.5rem !important;
    }

    & h2 :is(b, strong) {
      font-weight: 900;
      background: #67b26f linear-gradient(135deg, #2c82ad, ease-in-out, #67b26f);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
  }
`;

class ExpenseInfoBox extends Component {
  render() {
    return (
      <div className={styles.expense}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-building-community"
          width="196"
          height="196"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="rgb(51, 51, 56)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8" />
          <line x1="13" y1="7" x2="13" y2="7.01" />
          <line x1="17" y1="7" x2="17" y2="7.01" />
          <line x1="17" y1="11" x2="17" y2="11.01" />
          <line x1="17" y1="15" x2="17" y2="15.01" />
        </svg>
        <div>
          <h2>
            Ask your manager to <strong>get a subscription</strong> for you.
          </h2>
          <p>
            <strong>
              Most employers are happy to pay for tooling. Use our <Link to="/dear-manager/">example letter</Link> to ask your manager for a Polypane subscription.
            </strong>
          </p>
        </div>
      </div>
    );
  }
}

export default ExpenseInfoBox;
